import React, { useContext } from 'react';
import { Navigate } from "react-router-dom";
import { UserContext } from '../context/UserContext'; // ✅ Context Import kiya

const ProtectedRoute = ({ children }) => {
  // 1. Context se 'loading' state nikalo
  const { loading } = useContext(UserContext);

  // 2. Local Storage Checks (Aapka Code)
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const adminName = localStorage.getItem("adminName") || sessionStorage.getItem("adminName");

  // --- 🛑 FIX: WAITING ROOM (Loading Check) ---
  // Jab tak UserContext data fetch kar raha hai, tab tak Spinner dikhao.
  // Agar ye nahi lagayenge, to page load hote hi wo shayad Login par bhej dega.
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', background: '#f8f9fa' }}>
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading App...</span>
        </div>
      </div>
    );
  }

  // --- 👇 AAPKA PURANA LOGIC (Safe hai ab) ---
  
  // DEBUG Log
  console.log("🛡️ USER GUARD CHECK:", { tokenFound: !!token, adminFound: !!adminName });

  // CASE 1: Admin Check
  if (adminName) {
    console.warn("⛔ Blocked: Admin trying to access User Home.");
    return <Navigate to="/admin" replace />;
  }

  // CASE 2: Token Check
  if (!token) {
    console.warn("⛔ Blocked: No Token Found.");
    return <Navigate to="/login" replace />;
  }

  // CASE 3: Sab sahi hai
  return children;
};

export default ProtectedRoute;